import { Stack, Text, Title } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { freightNoCarriersMessageMessages } from './freight-no-carriers-message-messages';

type FreightNoCarriersMessageProps = Record<string, never>;

export const FreightNoCarriersMessage = ({}: FreightNoCarriersMessageProps) => {
  return (
    <Stack data-testid='freight-no-carriers-message' gap='xs'>
      <Title fw={600} order={4}>
        <FormattedMessage {...freightNoCarriersMessageMessages.title} />
      </Title>
      <Text c='dimmed'>
        <FormattedMessage
          {...freightNoCarriersMessageMessages.body}
          values={{
            contact: (chunks) => <a href='mailto:VolumeQuoting@shipstation.com'>{chunks}</a>,
          }}
        />
      </Text>
    </Stack>
  );
};
